<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
// import DevicePixelRatio from './assets/js/devicePixelRatio'
export default {
  name: 'App',
  created () {
    // new DevicePixelRatio().init()
  }
}
</script>

<style>
</style>
